import { render, staticRenderFns } from "./expired.vue?vue&type=template&id=20541020&scoped=true&"
import script from "./expired.vue?vue&type=script&lang=js&"
export * from "./expired.vue?vue&type=script&lang=js&"
import style0 from "./expired.vue?vue&type=style&index=0&id=20541020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20541020",
  null
  
)

export default component.exports